import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CustomIconService } from './services/custom-icon.service';
import { APP_ICONS } from './common/constants';
import { LanguageHelperService } from './services/language.service';

/**
 * This component is the main holder of the app.
 */
@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    standalone: true,
    providers: [],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  // Inject CustomIconService.
  private readonly customIconService = inject(CustomIconService);
  // Inject LanguageHelperService to initialize it on app startup.
  // The service handles language detection and setup in its constructor.
  private readonly languageHelperService = inject(LanguageHelperService);

  /**
   * A lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   */
  ngOnInit(): void {
    this.getAllSvgs();
  }

  /**
   * Get all svgs.
   */
  getAllSvgs(): void {
    // Add all icons to MatIconRegistry.
    this.customIconService.addCustomIcons(APP_ICONS);
    // Fetch all the icons.
    this.customIconService.fetchCustomIcons(APP_ICONS);
  }
}
